import React from "react"
import { FaCode, FaSketch, FaSeedling } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="details-icon" />,
    title: "Collaborate with others",
    text: `Find others to work with to build the personal project of your dreams.`,
  },
  {
    id: 2,
    icon: <FaSketch className="details-icon" />,
    title: "Prepare for interviews",
    text: `Connect with peers who can help you practice technical skills`,
  },
  {
    id: 3,
    icon: <FaSeedling className="details-icon" />,
    title: "Descover Paid Gigs",
    text: `Professionals and hobbiests can seek out paid collaborations`,
  },
]
